// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1Ki6s","error":"Textarea_error__3iL-R","readonly":"Textarea_readonly__3mqqg","disabled":"Textarea_disabled__2S6y0"};